import type{ BackendStage, TransformedStage } from './types';

export const transformStage = (entry: BackendStage): TransformedStage => ({
  id: entry.id,
  sportId: entry.sportId,
  tournamentUnionId: entry.tournamentUnionId,
  tournamentId: entry.tournamentId,
  name: entry.name,
  priority: entry.priority,
  promotionLevel: entry.promotionLevel,
});
